import { useField } from 'remix-validated-form'
import { useState } from 'react'
import { stripHtml } from 'string-strip-html'
import { classNames as cn } from '~/helpers/string'

interface CheckboxInputProps {
  label?: string
  labelClass?: string
  id?: string
  name: string
  checked?: boolean
  disabled?: boolean
  optional?: boolean
  onChange?: (checked: boolean) => void
  size?: 'sm' | 'md'
}

const VariantMap = {
  sm: 'w-3.5 h-3.5 border-[0.6px]',
  md: 'w-[18px] h-[18px] border-[1px]'
}

export default function CheckboxInput(props: CheckboxInputProps) {
  const { size = 'sm' } = props
  const { error } = useField(props.name)
  const defaultChecked = props.checked ? props.checked : false
  const [isChecked, setIsChecked] = useState(defaultChecked)

  return (
    <>
      <div className="flex select-none items-start gap-2">
        <input
          className={cn(
            "text-brand-primary-500 mt-0.5 rounded-sm cursor-pointer focus:ring-0 focus:ring-transparent",
            VariantMap[size],
            props.disabled ? 'border-brand-gray-400 pointer-events-none cursor-auto' : 'border-brand-gray-700 hover:border-brand-primary-500 focus:border-brand-primary-500'
          )}
          type="checkbox"
          key={props.id}
          id={props.id}
          name={props.name}
          value="true"
          checked={isChecked}
          disabled={props.disabled}
          onChange={() => {
            setIsChecked((prev) => !prev)
            props.onChange?.(!isChecked)
          }}
        />
        {props.label && (
          <label
            className={`${props.labelClass ?? 'text-sm prose-a:border-b prose-a:border-brand-primary-500'} ${props.disabled ? 'text-brand-gray-400' : 'text-brand-gray-700'}`}
            htmlFor={props.id}
          >
            <span
              dangerouslySetInnerHTML={{
                __html: stripHtml(props.label, { ignoreTags: ['a'] }).result,
              }}
            />
            {!props.optional && <span className="asterisk" />}
          </label>
        )}
      </div>

      {error && <span className="text-sm text-danger-500">{error}</span>}
    </>
  )
}
